import { Select } from "@dropbox/dig-components/text_fields";
import { useAvailableModels } from "@mirage/service-conversation/hooks/useAvailableModels";
import i18n from "@mirage/translations";
import { useMemo } from "react";

export const ModelSelect = ({
  value,
  onChange,
}: {
  value: string;
  onChange: (model: string) => void;
}) => {
  const { availableModels } = useAvailableModels();
  const certifiedModelOptions = useMemo(() => {
    const defaultModel = {
      value: "default",
      label: i18n.t("model_picker_default_model_label"),
    };

    const certifiedModels = availableModels.models
      .filter((model) => model.isCertified)
      .map((model) => ({
        value: model.id,
        label: model.displayName,
      }));

    return [defaultModel, ...certifiedModels];
  }, [availableModels]);

  return (
    <Select id="model" value={value} onChange={onChange}>
      {certifiedModelOptions.map((option) => (
        <Select.Option key={option.value} value={option.value}>
          {option.label}
        </Select.Option>
      ))}
    </Select>
  );
};
